<template>
	<router-link
		v-if="name === 'Media'"
		:to="`/campaign-editor-workspace/${currentCampaignId}/${route}`"
		tag="button"
		class="brand-builder-tool"
		@click.native="togglePreview(route)"
	>
		<span class="icon" :class="{ compactIcon: !expandedMenu }">
			<font-awesome-icon :icon="[iconWeight, icon]" />
		</span>
		<span class>{{ name }}</span>
	</router-link>

	<router-link
		v-else-if="name === 'Text' || name === 'Videos'"
		:to="`/campaign-editor-workspace/${currentCampaignId}/${route}`"
		tag="button"
		class="brand-builder-tool"
		:class="{ disabled: selectedAudienceType === null && allowDisable }"
		:disabled="selectedAudienceType === null && allowDisable"
		@click.native="togglePreview(route)"
	>
		<span class="icon" :class="{ compactIcon: !expandedMenu }">
			<font-awesome-icon :icon="[iconWeight, icon]" />
		</span>
		<span class>{{ name }}</span>
	</router-link>

	<router-link
		v-else-if="name === 'Layout'"
		:to="`/campaign-editor-workspace/${currentCampaignId}/${route}`"
		tag="button"
		class="brand-builder-tool"
		:class="{ disabled: disableLayoutTool }"
		:disabled="disableLayoutTool"
		@click.native="togglePreview(route)"
	>
		<span class="icon" :class="{ compactIcon: !expandedMenu }">
			<font-awesome-icon :icon="[iconWeight, icon]" />
		</span>
		<span class>{{ name }}</span>
	</router-link>

	<router-link
		v-else
		:to="`/campaign-editor-workspace/${currentCampaignId}/${route}`"
		tag="button"
		class="brand-builder-tool"
		:class="{ disabled: !routeAllowed.additional && allowDisable }"
		:disabled="!routeAllowed.additional && allowDisable"
		@click.native="togglePreview(route)"
	>
		<span class="icon" :class="{ compactIcon: !expandedMenu }">
			<font-awesome-icon :icon="[iconWeight, icon]" />
		</span>
		<span class>{{ name }}</span>
	</router-link>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { MEDIA_ID } from '@/constants/brand-builder';

export default {
	name: 'BrandBuilderTool',
	props: {
		icon: String,
		iconWeight: String,
		name: String,
		route: String,
		currentCampaignId: String,
		allowDisable: Boolean,
	},
	computed: {
		...mapState({
			expandedMenu: (state) => state.menus.expandedMenu,
			selectedAudienceType: (state) =>
				state.brandBuilderEditor.selectedAudienceType,
			selectedMediaType: (state) => state.brandBuilderEditor.selectedMediaType,
			selectedDesign: (state) => state.brandBuilderEditor.selectedDesign,
			routeAllowed: (state) => state.brandBuilderEditor.routeAllowed,
			prevBBRoute: (state) => state.brandBuilderEditor.prevBBRoute,
		}),
		disableLayoutTool() {
			/* Powerpoints don't go to text so Layout (design) should be enabled if we have an audience */
			const powerpointWithAudience =
				this.selectedMediaType === MEDIA_ID.POWERPOINT &&
				this.selectedAudienceType !== null;
			return (
				!this.routeAllowed.design &&
				this.allowDisable &&
				!powerpointWithAudience
			);
		},
	},
	methods: {
		...mapActions(['toggleSmPreview', 'setPrevBBRoute']),

		togglePreview(route) {
			if (route !== 'sm-preview' && this.prevBBRoute === route) {
				this.toggleSmPreview();
			} else if (route !== 'sm-preview' && this.prevBBRoute !== route) {
				this.toggleSmPreview('off');
			} else if (route === 'sm-preview') {
				this.toggleSmPreview('on');
			}

			this.setPrevBBRoute(route);
		},
	},
	data() {
		return {
			showPreview: false,
		};
	},
};
</script>

<style scoped lang="scss">
.brand-builder-tool {
	height: $brand-builder-tool-height;
	width: 100px;
	padding: 30px $base-padding;
	box-sizing: border-box;
	text-align: center;
	border: unset;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-color: transparent;
	width: 100%;
	@include typo--roboto__medium;
	font-size: $b360-font-size--small;
	color: $text-base-color;
	line-height: 1;
	transition: $b360-motion-selection;
	scroll-snap-align: start;
	box-shadow: inset 0 -#{$b360-border-width-thin} 0 0 $border-color-light;

	@include sm {
		min-width: 80px;
		width: 100%;
		box-shadow: inset #{$b360-border-width-thin} 0 0 0 $border-color-light;
	}

	&.router-link-exact-active,
	&:hover {
		box-shadow: inset $b360-border-width-medium 0 0 0 $brand-teal;
		background-color: $highlight-color__teal;
		color: $brand-teal;
		@include sm {
			box-shadow: inset 0 $b360-border-width-medium 0 0 $brand-teal;
		}
	}

	.icon {
		color: $brand-teal;
		@include rem(font-size, 28px);
		margin-bottom: 12px;
	}

	.compactIcon {
		width: auto;
	}

	&.disabled {
		color: $b360-color--gray__light;

		.icon {
			color: inherit;
		}
	}
}
</style>
